<template lang="pug">
  .stripe.payments.component
    stripe-elements( 
      ref="card" 
      locale='$i18n.locale' 
      :pk="pk" 
      :amount="amount" 
      @token="tokenize" 
      @loading="loading = $event" 
    )

    bf-flex
      bf-button.bright( @click.native="submit" ) 
        template( v-slot:text ) Submit
</template>

<script>
  import { fc } from '@/main'
  import { StripeElements } from 'vue-stripe-checkout'

  export default {
    
    components: {
      StripeElements
    },

    data() {
      return {
        amount: 1500,
        loading: false,
        pk: 'pk_test_51HjvL9JFyJOUPNWtPPRql5yF3puh2sJAegFav7mUnbRsPKU9pygXLUPEZskIRuXXaG3REAYbej1kunlSf4z8HbZl00FQwIWT8j', 
        token: null,
        charge: null,
        description: 'BlueFaucet Subscription'
      }
    },

    methods: {
      submit() {
        console.log('subscribing')
        this.$emit( 'subscribing' )

        this.$refs.card.submit()
      },

      tokenize( token ) {
        fc.httpsCallable( 'charge' )({ source: token.id }).then( res =>
          // console.log( 'charged' )
          this.$emit( 'subscribed' )
        )
      }
    }
  }
</script>